document.addEventListener('DOMContentLoaded', () => {

    document.addEventListener('click', (e) => {
        // if(isChild(e.target, '[size-chart-opener]')) openSizeChart(e);
        if(isChild(e.target, '[embed-content-opener]')) openEmbedContent(e);
    })

    openSizeChart = function (e) {
        const target = e.target.closest('[size-chart-opener]') || e.target;
        if(!target) return;

        popup.open();
        fetch(target.dataset.url)
            .then(response => response.text())
            .then(responseText => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const source = html.querySelector('.pop-up-inner');
                popup.load(source);
                init(popup.outer);
            })
    }

    openEmbedContent = function (e) {
        const target = e.target.closest('[embed-content-opener]') || e.target;
        if(!target) return;

        popup.open();
        fetch(target.dataset.url)
            .then(response => response.text())
            .then(responseText => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const source = html.querySelector('.pop-up-inner');
                popup.load(source);
                init(popup.outer, 'quick-view');
            })
    }

}, { passive: true});

const product = {
    init: function () {
        this.section = document.querySelector('#main-product');
        this.mountSliders();
    },
    mountSliders: function () {
        const section = document.querySelector('#main-product .left');

        if(this.imgs && this.imgs instanceof Slider) this.imgs.destroy();

        this.imgs = new Slider(section.querySelector('[slider].imgs'));

        if(section.querySelector('[slider].thumbs')){

            let thumbsOptions = {
                navFor: this.imgs,
                navForActivePosition: 1,
                autoPosition:false
            }

            let verticalonPc = {
                vertical: true
            }

            let verticalOnMobile = {
                responsive: [
                    {
                        breakpoint: 1136,
                        settings: {
                            vertical: true
                        }
                    }
                ]
            }

            let horizontalOnMobile = {
                responsive: [
                    {
                        breakpoint: 1136,
                        settings: {
                            vertical: false
                        }
                    }
                ]
            }

            if(section.querySelector('[slider].thumbs').getAttribute('slider-direction') == 'vertical'){
                thumbsOptions = {...thumbsOptions, ...verticalonPc}
            }

            if(section.querySelector('[slider].thumbs').getAttribute('slider-direction-s') == 'vertical'){
                thumbsOptions = {...thumbsOptions, ...verticalOnMobile}
            } else {
                thumbsOptions = {...thumbsOptions, ...horizontalOnMobile}
            }

            if(this.thumbs && this.thumbs instanceof Slider) this.thumbs.destroy();

            this.thumbs = new Slider(section.querySelector('[slider].thumbs'), thumbsOptions);
            this.imgs.nav = this.thumbs;
            this.imgs.buildNav();
            this.thumbs.buildNavFor();
        }

        setTimeout(() => {
            const slides = section.querySelectorAll('.imgs .img');
            slides.forEach((slide, index) => {
                if(slide.classList.contains('video')){
                    slide.productVideo = new productVideo(slide, this.imgs, index);
                }
            })
        }, 1000)
    }
}

class VariantRadios extends HTMLElement{
    constructor(){
        super();

        this.inputId = this.querySelector('[name="id"]');
        this.section = document.querySelector('#main-product');

        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange () {
        this.updateOptions();
        this.updateMasterId();

        if(!this.currentVariant) return;
        
        this.updateHistory();
        this.updateInput();
        this.updateContent();
        this.updateImage();
    }

    updateOptions () {
        const fieldsets = Array.from(this.querySelectorAll('.inputs'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
            return this.options[index] === option;
            }).includes(false);
        });
    }

    updateHistory () {
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateInput () {
        if(this.inputId) this.inputId.value = this.currentVariant.id;
    }

    updateContent () {

        this.section.classList.add('variant-changing');

        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then(response => response.text())
            .then(text => {
                const html = new DOMParser().parseFromString(text, 'text/html');
                const toChange = ['[variant-changing]'];
                toChange.forEach(string => {
                    let sources = html.querySelectorAll(string);
                    let destinations = document.querySelectorAll(string);
                    sources.forEach((source, index) => {
                        if(!destinations[index]) return;
                        destinations[index].innerHTML = source.innerHTML;
                    })
                })
                
                this.section.classList.remove('variant-changing');
                init(this.section);
            })
    }

    updateImage () {
        if(this.currentVariant.featured_media) product.imgs.goToSlide(this.currentVariant.featured_media.position - 1);
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }  
}
customElements.define('variant-radios', VariantRadios);

class VariantBundle extends VariantRadios{
    constructor(){
        super();
    }

    onVariantChange () {
        this.updateMasterId();

        if(!this.currentVariant) return;
        
        this.updateHistory();
        this.updateContent();
        this.updateImage();
    }

    updateMasterId () {
        const id = parseInt(Array.from(this.querySelectorAll('input[type="radio"]')).find((input) => input.checked).value);
        this.getVariantData().forEach((variant) => {
            if(variant.id == id) this.currentVariant = variant; 
        });
    }
}
customElements.define('variant-bundle', VariantBundle);

class LinkedProducts extends HTMLElement{
    constructor(){
        super();

        this.section = document.querySelector('#main-product');

        this.addEventListener('change', this.onChange.bind(this));
    }

    onChange () {
        this.updateProduct()

        if(this.product){
            this.updateContent();
            this.renderOtherSections();
        }
    }

    updateProduct () {
        const inputs = this.querySelectorAll('input');
        inputs.forEach(input => {
            if(input.checked) this.product = input.value;
        })
    }

    async updateContent () {
        this.section.classList.add('product-changing');

        window.history.replaceState({ }, '', `/products/${this.product}`);

        const response = await fetch(`/products/${this.product}?section_id=${this.dataset.section}`);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const toChange = ['[product-changing]', '[variant-changing]'];
        toChange.forEach(string => {
            let sources = html.querySelectorAll(string);
            let destinations = document.querySelectorAll(string);
            sources.forEach((source, index) => {
                if(!destinations[index]) return;
                destinations[index].innerHTML = source.innerHTML;
            })
        })

        this.section.classList.remove('product-changing');
        product.init();
        init(this.section);

        try{
            loadFbt();
        } catch(error){}
    }

    async renderOtherSections () {
        const toChanges = Array.from(document.querySelectorAll('[to-change]'));
        
        const HTMLs = await Promise.all(toChanges.map(toChange => {
            const url = `?section_id=${toChange.dataset.section}`;
            return this.getHTML(url);
        }));

        HTMLs.forEach(html => {
            const sectionId = html.querySelector('[data-section]').getAttribute('data-section');
            const destination = document.querySelector(`#shopify-section-${sectionId}`);
            if(destination) {
                destination.innerHTML = html.innerHTML;
            }
        })
    }

    async getHTML (url) {
        const response = await fetch(url)
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const toRender = html.querySelector('.shopify-section');
        return toRender;
    }
}
customElements.define('linked-products', LinkedProducts)

class productVideo{
    constructor (element, imgs, index) {

        this.imgs = imgs;
        this.index = index;
        this.element = element;

        this.player = this.element.querySelector('video');
        this.muted = this.element.querySelector('.muted');

        this.player.addEventListener('click', this.toggleMute.bind(this));

        this.imgs.element.addEventListener('changeSlide', (e) => {
            this.onSlideChange(e);
        }, { passive: true });

        this.observer = new IntersectionObserver((e) => {
            this.onIntersection(e);
        })
        this.observer.observe(element);
    }

    play () {
        this.player.muted = false;
        this.muted.classList.add('hidden');
        this.player.play();
    }

    pause () {
        this.player.pause();
    }

    toggleMute () {
        if(this.player.muted){
            this.player.muted = false;
            this.muted.classList.add('hidden');
        }
        else{
            this.player.muted = true;
            this.muted.classList.remove('hidden');
        }
    }

    onSlideChange(e) {
        setTimeout(() => {
            if(e.detail.index == this.index) this.play();
            else this.pause();
        }, "500")
    }

    onIntersection([entry]) {
        if(!entry.isIntersecting){
            this.pause();
        }
    }
}

class stickyAtc extends HTMLElement {
    constructor() {
        super();

        this.atc = document.querySelector('.main-product .atc');

        if(!this.atc) return;
        
        new IntersectionObserver(this.callback.bind(this)).observe(this.atc);
    }

    callback (e) {
        let state = e[0].isIntersecting;
        if(state == false) this.classList.add('active');
        else this.classList.remove('active');
    }
}
customElements.define('sticky-atc', stickyAtc);

document.addEventListener('DOMContentLoaded', () => {
    product.init();
})

